/* eslint-disable react/prop-types */
import React from 'react';
import { Box } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { motion } from 'framer-motion';
import ColorButtonPurple from './ColorButtonPurple.js';
import ColorButtonWhite from './ColorButtonWhite.js';
import TextFieldPurple from './TextFieldPurple';
import StepBar from './StepBar.js';
import CopyRight from './CopyRight.js';
import { Link } from 'react-router-dom';

class Step1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = { numColorPeople: '#BCBCBC', numColorArea: '#BCBCBC', numColorRent: '#BCBCBC' };
  }

  handeleFocusPeople() {
    this.setState({ numColorPeople: 'black' });
  }

  handeleFocusArea() {
    this.setState({ numColorArea: 'black' });
  }

  handeleFocusRent() {
    this.setState({ numColorRent: 'black' });
  }

  render() {
    return (
      <div>
        <motion.div
          className="contents-inner"
          animate={{
            x: 0,
            opacity: 1,
          }}
          initial={{
            x: 100,
            opacity: 0,
          }}
          exit={{
            x: -100,
            opacity: 0,
          }}
          transition={{
            duration: 0.2,
          }}
        >
          <h2 className="question">まずは基本的な御社の情報を教えてください。</h2>

          <Box textAlign="center">
            <Grid container direction="column">
              <Grid container alignItems="center" justify="center">
                <Grid item xs={1}></Grid>
                <Grid item xs={2}>
                  <Box textAlign="center">
                    <h3 className="imput-tittle">社員数</h3>
                  </Box>
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <Grid container alignItems="center" justify="center">
                <Grid item xs={1}></Grid>
                <Grid item xs={2}>
                  <Box textAlign="center">
                    <TextFieldPurple
                      id="outlined-basic"
                      variant="outlined"
                      margin="dense"
                      value={this.props.data.office_people}
                      onChange={(e) => {
                        this.props.handleOfficePeopleChange(e.target.value);
                      }}
                      onFocus={() => this.handeleFocusPeople()}
                      inputProps={{
                        style: {
                          fontSize: 30,
                          textAlign: 'center',
                          fontFamily: 'Noto Sans JP',
                          color: this.state.numColorPeople,
                        },
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={1}>
                  <Box textAlign="left" paddingLeft={1}>
                    <p className="imput-tittle"> 人</p>
                  </Box>
                </Grid>
              </Grid>

              <Grid container alignItems="center" justify="center">
                <Grid item xs={1}></Grid>
                <Grid item xs={2}>
                  <Box textAlign="center">
                    <h3 className="imput-tittle">オフィスの面積</h3>
                  </Box>
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <Grid container alignItems="center" justify="center">
                <Grid item xs={1}></Grid>
                <Grid item xs={2}>
                  <Box textAlign="center">
                    <TextFieldPurple
                      id="outlined-basic"
                      variant="outlined"
                      margin="dense"
                      value={this.props.data.office_area}
                      onChange={(e) => {
                        this.props.handleOfficeAreaChange(e.target.value);
                      }}
                      onFocus={() => this.handeleFocusArea()}
                      inputProps={{
                        style: {
                          fontSize: 30,
                          textAlign: 'center',
                          fontFamily: 'Noto Sans JP',
                          color: this.state.numColorArea,
                        },
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={1}>
                  <Box textAlign="left" paddingLeft={1}>
                    <p className="imput-tittle">㎡</p>
                  </Box>
                </Grid>
              </Grid>

              <Grid container alignItems="center" justify="center">
                <Grid item xs={1}></Grid>
                <Grid item xs={2}>
                  <Box textAlign="center">
                    <h3 className="imput-tittle">オフィスの賃料</h3>
                  </Box>
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <Grid container alignItems="center" justify="center">
                <Grid item xs={1}></Grid>
                <Grid item xs={2}>
                  <Box>
                    <TextFieldPurple
                      id="outlined-basic"
                      variant="outlined"
                      margin="dense"
                      value={this.props.data.office_rent}
                      onChange={(e) => {
                        this.props.handleOfficeRentChange(e.target.value);
                      }}
                      onFocus={() => this.handeleFocusRent()}
                      inputProps={{
                        style: {
                          fontSize: 30,
                          textAlign: 'center',
                          fontFamily: 'Noto Sans JP',
                          color: this.state.numColorRent,
                        },
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={1}>
                  <Box textAlign="left" paddingLeft={1}>
                    <p className="imput-tittle">万円/月</p>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Box>

          <Box paddingTop={5}>
            <Grid container justify="center">
              <Grid item xs={2}>
                <Box m={1} textAlign="right">
                  <ColorButtonWhite size="large" variant="outlined" component={Link} to="/">
                    BACK
                  </ColorButtonWhite>
                </Box>
              </Grid>
              <Grid item xs={2}>
                <Box m={1} textAlign="left">
                  <ColorButtonPurple size="large" variant="outlined" component={Link} to="/step2">
                    NEXT
                  </ColorButtonPurple>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <StepBar step="step1" />
          <Box marginTop={3}>
            <CopyRight />
          </Box>
        </motion.div>
      </div>
    );
  }
}

export default Step1;
